const adminTranslations = {
  fi: {
    admin: {
      common: {
        cancel: 'Peruuta',
        save: 'Tallenna',
        saving: 'Tallennetaan...',
        saved: 'Tallennettu!',
        create: 'Luo',
        add: 'Lisää',
        delete: 'Poista',
        edit: 'Muokkaa',
        copy: 'Kopioi',
        on: 'Päällä',
        off: 'Pois',
        visible: 'Näkyvissä',
        hidden: 'Piilotettu',
        expanded: 'Avattuna',
        collapsed: 'Kiinni',
        active: 'Aktiivinen',
        blocked: 'Estetty',
        name: 'Nimi',
        role: 'Rooli',
        actions: 'Toiminnot',
        day: 'Päivä',
        unknown: 'Tuntematon',
        unknownError: 'Tuntematon virhe',
        networkError: 'Verkkovirhe',
        deleteFailed: 'Poisto epäonnistui',
        saveFailed: 'Tallennus epäonnistui',
        loadingSettings: 'Ladataan asetuksia...',
        updatedAt: 'Päivitetty:',
        show: 'Näytä',
        hide: 'Piilota',
        warning: 'Varoitus',
        warningExclaim: 'Varoitus!',
        solution: 'Ratkaisu:',
        minutes: 'min',
        hoursShort: 'h',
        players: 'Pelaajat',
        playersCount: '{count} pelaajaa',
        playerCount: 'Pelaajamäärä',
        rank: 'Sijoitus',
        rankNth: '{rank}. sija',
        points: 'Pisteet',
        pointsLabel: 'Pisteet',
        season: 'Kausi',
        seasonLabel: 'Kausi {range}',
        gamesCount: '{count} peliä',
        sessionsCount: '({count} sessiota)',
        seasonsCount: '({count} kautta)',
        productsCount: 'Tuotteita: {count}',
        commission: 'Komissio: {percent}%',
        code: 'Koodi:',
        executing: 'Suoritetaan...',
        confirm: 'Vahvista',
        template: 'MALLI',
        templateParen: '(malli)',
        globalParen: '(globaali)',
        platformDefault: 'Alustan oletus',
        platformDefaultBadge: 'Platform Default',
        notDefined: 'Ei määritelty',
        selectPlaceholder: '-- Valitse --',
        updatedPrefix: 'Päivitetty:'
      },
      roles: {
        member: 'Jäsen',
        board: 'Hallitusjäsen',
        admin: 'Ylläpitäjä'
      },
      months: {
        1: 'Tammikuu',
        2: 'Helmikuu',
        3: 'Maaliskuu',
        4: 'Huhtikuu',
        5: 'Toukokuu',
        6: 'Kesäkuu',
        7: 'Heinäkuu',
        8: 'Elokuu',
        9: 'Syyskuu',
        10: 'Lokakuu',
        11: 'Marraskuu',
        12: 'Joulukuu'
      },
      languages: {
        fi: 'Suomi',
        en: 'English',
        sv: 'Svenska'
      },
      panel: {
        title: 'Ylläpito',
        scoringSettings: 'Pisteytysasetukset',
        resultsMaintenance: 'Tulosten ylläpito',
        systemSettings: 'Järjestelmäasetukset',
        adsManagement: 'Mainosten hallinta',
        clubSettings: 'Klubin asetukset',
        addMember: 'Lisää jäsen',
        nicknamePlaceholder: 'Nimimerkki',
        userAdded: 'Käyttäjä lisätty!',
        userAddError: 'Virhe käyttäjän lisäyksessä',
        regenerateConfirm: 'Haluatko varmasti luoda uuden linkin? Vanha lakkaa toimimasta.',
        regenerateFailed: 'Linkin uusiminen epäonnistui',
        regenerateSuccess: 'Uusi linkki luotu ja kopioitu leikepöydälle.',
        linkFetchFailed: 'Linkin haku epäonnistui',
        linkCopyFailed: 'Linkin kopiointi epäonnistui',
        roleUpdateError: 'Virhe roolin päivityksessä',
        deleteUserTitle: 'Poista käyttäjä pysyvästi?',
        deleteNotPossible: 'Poisto ei ole mahdollista:',
        deleteNotPossibleHint: 'Käytä käyttäjän estämistä (deactivate) sen sijaan, jotta käyttäjän tiedot säilyvät mutta hän ei voi kirjautua sisään.',
        deleteWarning: 'Tämä poistaa käyttäjän pysyvästi. Jos käyttäjällä on pelihistoriaa, peli-iltojen osallistumisia tai muita viittauksia, poisto ei ole mahdollista - käytä sen sijaan estämistä.',
        deletePermanently: 'Poista pysyvästi',
        memberList: 'Jäsenlista ({count})',
        showOnlyActive: 'Näytä vain aktiiviset',
        copyLinkTitle: 'Kopioi linkki',
        newLinkTitle: 'Uusi linkki',
        blockTitle: 'Estä (Soft Delete)',
        activateTitle: 'Aktivoi',
        deletePermanentlyTitle: 'Poista pysyvästi'
      },
      settings: {
        title: 'Klubin asetukset',
        loading: 'Ladataan asetuksia...',
        categories: {
          features: 'Ominaisuudet',
          bgg: 'BGG',
          leaderboard: 'Leaderboard',
          analytics: 'Analyysit',
          ai: '🤖 AI-asetukset',
          prompts: '💬 Promptit',
          general: '⚙️ Yleiset',
          email: '📧 Sähköposti',
          other: '📦 Muut'
        },
        features: {
          gameNightsAdminOnly: 'Ehdota peli-iltaa vain Admin',
          gameNightsAdminOnlyHelp: 'Kun päällä, vain ylläpitäjät voivat luoda uusia peli-iltaehdotuksia. Kaikki jäsenet voivat silti ilmoittautua.'
        },
        bgg: {
          username: 'BGG-käyttäjänimi',
          usernameHelp: 'Käyttäjänimi, jonka kokoelmasta pelit haetaan.',
          usernamePlaceholder: 'esim. peliklubi123',
          autoSync: 'Automaattinen synkronointi',
          autoSyncHelp: 'Synkronoi pelit automaattisesti BGG:stä päivittäin.',
          lastSync: 'Viimeisin synkronointi',
          saveButton: 'Tallenna BGG-asetukset'
        },
        leaderboard: {
          visibleMetrics: 'Näytettävät mittarit',
          visibleMetricsHelp: 'Valitse mitkä mittarit näytetään Etusivun leaderboard-taulukossa.',
          sort: 'Lajittelu',
          sortHelp: 'Valitse sarake ja suunta etusivun leaderboard-järjestykselle. Vain näkyvät sarakkeet (ja Pelit) ovat valittavissa.',
          sortColumn: 'Lajittelusarake',
          sortDirection: 'Lajittelusuunta',
          sortDesc: 'Laskeva (suurin ensin)',
          sortAsc: 'Nouseva (pienin ensin)',
          saveButton: 'Tallenna Leaderboard-asetukset',
          metrics: {
            time: { label: 'Aika', description: 'Kokonaispeliaika' },
            points: { label: 'Menestyspisteet', description: 'Kokonaismenestyspisteet' },
            winRate: { label: 'Voittoprosentti per oma peli', description: 'Voittoprosentti omissa peleissä' },
            avgPoints: { label: 'Keskimääräinen voittopisteiden määrä per pelattu peli', description: 'Keskimäärin ansaitut pisteet per peli' }
          },
          sortLabels: {
            games: 'Pelit',
            time: 'Aika',
            points: 'Menestyspisteet',
            winRate: 'Voitto-%',
            avgPoints: 'Keskim. MP / peli'
          }
        },
        analytics: {
          visibilityTitle: 'Analyysien näkyvyys ja järjestys',
          visibilityHelp: 'Määritä mitkä analyysit näytetään ja missä järjestyksessä. Voit myös määrittää ovatko ne oletuksena avattuna vai kiinni. Uudet osiot (Menestyspisteet, Mitalisijoitus-%, Mitalitaulukko) tulevat listaan automaattisesti, jos niitä ei vielä ole tallennettu.',
          saveButton: 'Tallenna Analyysit-asetukset'
        }
      },
      analyticsSections: {
        summary: 'Yhteenveto',
        longestGames: 'Pisimmät pelit',
        mostPlayed: 'Suosituimmat pelit',
        winRates: 'Voittoprosentit',
        winStreaks: 'Voittoputket',
        highestScores: 'Korkeimmat pisteet',
        closestGames: 'Tasaisimmat pelit',
        playerFavorites: 'Pelaajien suosikit',
        monthlyActivity: 'Kuukausiaktiivisuus',
        headToHead: 'Keskinäiset kohtaamiset',
        avgPointsPerGame: 'Keskimääräinen menestyspisteansio',
        pointsLeaderboard: 'Menestyspisteet',
        medalPercentage: 'Mitalisijoitus-%',
        medalTable: 'Mitalitaulukko',
        socialNemesis: 'Nemesis',
        socialKingmaker: 'Kingmaker',
        socialCloser: 'Closer',
        socialChoker: 'Choker',
        socialGiantSlayer: 'Giant Slayer',
        socialSpecialist: 'Specialist',
        socialRivalry: 'Rivalry',
        socialSkill: 'Skill-rating'
      },
      club: {
        title: 'Klubin asetukset',
        saveChanges: 'Tallenna muutokset',
        tabs: {
          branding: 'Ulkoasu',
          localization: 'Kieli',
          media: 'Media',
          scripts: 'Skriptit',
          seasons: 'Kausi'
        },
        branding: {
          title: 'Brändäys',
          clubName: 'Klubin nimi',
          clubNamePlaceholder: 'esim. Turun Noppanikkari',
          description: 'Kuvaus',
          descriptionPlaceholder: 'Lyhyt kuvaus klubista...',
          primaryColor: 'Pääväri',
          sampleColors: 'Esimerkkivärit:',
          logoPreviewAlt: 'Logon esikatselu'
        },
        localization: {
          title: 'Kieli ja alue',
          uiLanguage: 'Käyttöliittymän kieli',
          info: 'Kielen vaihtaminen vaikuttaa käyttöliittymän teksteihin. Käyttäjien syöttämä sisältö pysyy alkuperäisellä kielellä.'
        },
        media: {
          title: 'Kuvat ja videot',
          logoUrl: 'Logo URL',
          heroVideoUrl: 'Hero Video URL',
          heroVideoHelp: 'Video näytetään etusivun taustalla. Suositeltu koko: 1920x1080, MP4-muoto.'
        },
        scripts: {
          title: 'Mukautetut skriptit',
          warning: 'Skriptit suoritetaan tämän klubin sivuilla sellaisenaan (Google Analytics, widgetit). Lisää vain luotettavista lähteistä. iframe ja HTTP-osoitteet on estetty.',
          addScript: 'Lisää skripti',
          noDescription: 'Ei kuvausta',
          addFailed: 'Skriptin lisäys epäonnistui',
          deleteConfirm: 'Haluatko varmasti poistaa tämän skriptin?',
          modalTitle: 'Lisää skripti',
          position: 'Sijainti',
          description: 'Kuvaus',
          descriptionPlaceholder: 'esim. Google Analytics',
          script: 'Skripti',
          scriptPlaceholder: '<script>...</script>',
          positions: {
            head_start: 'Head (alussa)',
            head_end: 'Head (lopussa)',
            body_start: 'Body (alussa)',
            body_end: 'Body (lopussa)'
          }
        },
        seasons: {
          title: 'Kausiväli',
          info: 'Määrittele milloin kausi alkaa ja loppuu. Oletus on 1.8. - 30.6. Sessiot ryhmitellään automaattisesti kausiin näiden päivämäärien mukaan.',
          start: 'Kauden alku',
          end: 'Kauden loppu',
          preview: 'Esikatselu:',
          previewRange: 'Kausi: {startDay}.{startMonth}. - {endDay}.{endMonth}.',
          nextYear: ' (seuraavana vuonna)',
          saveButton: 'Tallenna kausiväli',
          maxDurationError: 'Kausi saa kestää enintään 12 kuukautta. Tarkista myös päivämäärät.',
          saveError: 'Kausivälin tallennus epäonnistui',
          migrationTitle: 'Vahvista migraatio',
          migrationBody: 'Sinulla on {total} sessiota, joista {affected} siirtyy eri kauteen uusilla asetuksilla.',
          migrationChanges: 'Muutokset:',
          migrationSessionLine: '{change}: {count} sessiota',
          migrationWarning: 'Mitä tapahtuu: Uudet kaudet luodaan automaattisesti ja sessiot siirretään niihin. Klubin eniten käytetty pisteytysstrategia valitaan kaikille kausille ja tulokset lasketaan uudelleen.',
          confirmMigration: 'Vahvista migraatio'
        }
      },
      results: {
        title: 'Tulosten ylläpito',
        subtitle: 'Hallinnoi pelisessioita kausittain. Voit muokata tai poistaa tuloksia.',
        loading: 'Ladataan tuloksia...',
        loadSessionError: 'Virhe ladattaessa session tietoja',
        errorPrefix: 'Virhe:',
        updateFailed: 'Päivitys epäonnistui',
        editSession: 'Muokkaa sessiota',
        deleteTitle: 'Haluatko varmasti poistaa?',
        deleteWarning: 'Tämä poistaa session ja kaikki siihen liittyvät tulokset pysyvästi.',
        noSessions: 'Ei sessioita',
        date: 'Päivä',
        game: 'Peli',
        scores: 'Pisteet',
        clickImageTitle: 'Klikkaa avataksesi kuvan',
        noImageTitle: 'Ei kuvaa',
        sessionImageAlt: 'Sessio'
      },
      scoring: {
        title: 'Pisteytysasetukset',
        loading: 'Ladataan pisteytysasetuksia...',
        loadFailed: 'Pisteytysasetusten lataus epäonnistui',
        tabs: {
          overview: 'Yleiskatsaus',
          strategies: 'Strategiat',
          seasons: 'Kaudet'
        },
        strategiesTab: 'Strategiat ({count})',
        seasonsTab: 'Kaudet ({count})',
        clubStrategiesTitle: 'Klubin pisteytysstrategiat',
        clubStrategiesHelp: 'Luo uusi strategia kopioimalla mallipohja tai oma strategia. Mallipohjia ei voi muokata, mutta ne voi ottaa käyttöön.',
        ownStrategies: 'Omat strategiat',
        noOwnStrategies: 'Ei omia strategioita. Luo uusi kopioimalla mallipohja.',
        templatesReadonly: 'Mallipohjat (vain luku)',
        copyForUse: 'Kopioi käyttöön',
        cloneTitle: 'Kopioi strategia',
        cloningFrom: 'Kopioidaan:',
        newStrategyName: 'Uuden strategian nimi',
        namePlaceholder: 'Anna nimi',
        copySuffix: ' (kopio)',
        deleteStrategyTitle: 'Poista strategia',
        deleteStrategyWarning: 'Strategia "{name}" on käytössä {count} kaudella. Valitse korvaava strategia ennen poistamista.',
        replacementStrategy: 'Korvaava strategia',
        replacementHelp: 'Kaudet, jotka käyttävät tätä strategiaa, päivitetään käyttämään valittua korvaavaa strategiaa.',
        deleteStrategyButton: 'Poista strategia',
        editStrategy: 'Muokkaa: {name}',
        customScoring: 'Mukautettu pisteytys',
        platformDefaultScoring: 'Alustan oletuspisteytys',
        customScoringHelp: 'Klubillasi on käytössä oma mukautettu pisteytys.',
        platformDefaultHelp: 'Käytössä on alustan oletuspisteytys. Voit luoda oman mukautetun pisteytyksen tarvittaessa.',
        creating: 'Luodaan...',
        createCustomScoring: 'Luo oma pisteytys',
        scoreTable: 'Pistetaulukko',
        scoreTableHelp: 'Näyttää pisteet kullekin sijoitukselle eri pelaajamäärillä',
        scoringRanges: 'Pisteytysvälit',
        playersRange: '{min}-{max} pelaajaa',
        playersRangeOpen: '{min}-∞ pelaajaa',
        strategyTypeTable: '📊 Taulukko',
        strategyTypeFormula: '📐 Kaava',
        formulaLabel: 'Kaava:',
        variablesLabel: 'Muuttujat:',
        strategyCloned: 'Strategia kopioitu!',
        cloneFailed: 'Kopiointi epäonnistui',
        strategyDeleted: 'Strategia poistettu!',
        strategyDeletedUpdated: 'Strategia poistettu ja kaudet päivitetty!',
        customScoringCreated: 'Mukautettu pisteytys luotu!',
        createFailed: 'Luonti epäonnistui',
        seasonStrategyUpdated: 'Kauden pisteytys päivitetty!',
        seasonPointsRecalculated: 'Kauden pisteet laskettu uudelleen.',
        updateFailed: 'Päivitys epäonnistui',
        seasonsTitle: 'Kaudet ja pisteytykset',
        seasonsHelp: 'Jokaiselle kaudelle voidaan valita oma pisteytysstrategia. Vaihto esikatsellaan ja laskee kauden sessioiden pisteet uudelleen.',
        noSeasons: 'Ei kausia vielä. Kaudet luodaan automaattisesti kun pelisessioita lisätään.',
        changeScoringTitle: 'Vaihda pisteytys',
        recalcTitle: 'Uudelleenlaskenta',
        recalcHelp: 'Strategian vaihto laskee kauden sessioiden liigapisteet uudelleen. Tarkista esikatselu ennen vahvistusta.',
        confirmRecalc: 'Vahvista ja laske uudelleen',
        diffPreview: {
          summary: '{sessions} sessiota, {results} tulosta. Muuttuu: {changedResults} tulosta ({changedSessions} sessiossa). Pistesumma {oldSum} → {newSum} ({delta}).',
          date: 'Pvm',
          game: 'Peli',
          player: 'Pelaaja',
          rank: 'Sija',
          old: 'Vanha',
          new: 'Uusi',
          truncated: 'Näytetään ensimmäiset muuttuneet rivit.',
          noChanges: 'Ei piste-eroja nykyisiin tuloksiin.'
        },
        calculator: 'Laskin (Esikatselu)',
        calculatorHelp: 'Testaa miten nykyiset asetukset vaikuttavat pisteisiin.'
      },
      strategyManager: {
        defaultTitle: 'Pisteytysstrategiat',
        loading: 'Ladataan pisteytysstrategioita...',
        selectStrategy: 'Valitse strategia',
        strategyName: 'Strategian nimi',
        strategyNamePlaceholder: 'Esim. Klubin oletus',
        descriptionOptional: 'Kuvaus (valinnainen)',
        descriptionPlaceholder: 'Esim. 2-8 pelaajaa taulukko, 9+ kaava',
        editNameTitle: 'Muokkaa nimeä',
        playerRanges: 'Pelaajamäärävälit',
        addRange: 'Lisää väli',
        noRanges: 'Ei pelaajamäärävälejä. Lisää ensimmäinen väli aloittaaksesi.',
        deleteRangeConfirm: 'Haluatko varmasti poistaa tämän välin?',
        typeTable: 'Taulukko',
        typeFormula: 'Kaava',
        addRangeTitle: 'Lisää pelaajamääräväli',
        rangeNameOptional: 'Nimi (valinnainen)',
        rangeNamePlaceholder: 'esim. Pienet pelit',
        minPlayers: 'Minimi pelaajamäärä',
        maxPlayers: 'Maksimi pelaajamäärä',
        noUpperLimit: 'Ei ylärajaa (∞)',
        strategyType: 'Strategiatyyppi',
        createRange: 'Luo väli',
        formulaSingleExpression: 'Kaava (yksittäinen lauseke)',
        formulaTemplates: 'Mallipohjat:',
        templateTop3: 'Top 3 saa pisteet',
        templateLinear: 'Lineaarinen (N pistettä → 1)',
        templateWinnerTakesAll: 'Voittaja vie kaiken',
        syntaxTitle: 'Syntaksi:',
        syntaxExpression: 'Kaavan tulee olla yksittäinen lauseke (ei sijoituksia =).',
        syntaxCondition: 'Ehto:',
        syntaxConditionExample: 'ehto ? arvo_tosi : arvo_epätosi',
        syntaxFunctions: 'Funktiot:',
        syntaxVariables: 'Muuttujat:',
        variablesHeading: 'Muuttujat:',
        fullPreviewTable: 'Täysi pistetaulukko (esikatselu)'
      },
      ads: {
        title: 'Mainosten hallinta',
        loading: 'Ladataan mainoshallintaa...',
        notEnabled: 'Tämä toiminto ei ole aktivoitu tälle klubille. SuperAdmin voi ottaa sen käyttöön klubin beta-toiminnoista.',
        tabs: {
          sponsors: 'Sponsorit',
          products: 'Tuotteet',
          analytics: 'Analytiikka'
        },
        sponsorsTitle: 'Sponsorit ({count})',
        addSponsor: 'Lisää sponsori',
        editSponsor: 'Muokkaa sponsoria',
        productsTitle: 'Tuotteet ({count})',
        addProduct: 'Lisää tuote',
        editProduct: 'Muokkaa tuotetta',
        analyticsTitle: 'Mainosanalytiikka (30 päivää)',
        impressions: 'Näyttöjä',
        clicks: 'Klikkejä',
        ctr: 'CTR',
        revenue: 'Tuotto',
        noAnalytics: 'Ei analytiikkadataa valitulta ajanjaksolta.',
        deleteProductConfirm: 'Poista tuote?',
        product: 'Tuote',
        sponsor: 'Sponsori',
        price: 'Hinta',
        category: 'Kategoria',
        priority: 'Prioriteetti',
        nameRequired: 'Nimi *',
        logoUrl: 'Logo URL',
        website: 'Verkkosivu',
        affiliateCode: 'Affiliate-koodi',
        commissionPercent: 'Komissio %',
        tier: 'Taso',
        sponsorRequired: 'Sponsori *',
        productNameRequired: 'Tuotenimi *',
        description: 'Kuvaus',
        imageUrl: 'Kuva URL',
        productUrlRequired: 'Tuote URL *',
        priceEur: 'Hinta €',
        salePriceEur: 'Tarjoushinta €',
        categories: {
          expansion: 'Lisäosa',
          accessory: 'Lisävaruste',
          game: 'Peli',
          snacks: 'Naposteltavat'
        }
      }
    }
  },
  en: {
    admin: {
      common: {
        cancel: 'Cancel',
        save: 'Save',
        saving: 'Saving...',
        saved: 'Saved!',
        create: 'Create',
        add: 'Add',
        delete: 'Delete',
        edit: 'Edit',
        copy: 'Copy',
        on: 'On',
        off: 'Off',
        visible: 'Visible',
        hidden: 'Hidden',
        expanded: 'Expanded',
        collapsed: 'Collapsed',
        active: 'Active',
        blocked: 'Blocked',
        name: 'Name',
        role: 'Role',
        actions: 'Actions',
        day: 'Day',
        unknown: 'Unknown',
        unknownError: 'Unknown error',
        networkError: 'Network error',
        deleteFailed: 'Deletion failed',
        saveFailed: 'Save failed',
        loadingSettings: 'Loading settings...',
        updatedAt: 'Updated:',
        show: 'Show',
        hide: 'Hide',
        warning: 'Warning',
        warningExclaim: 'Warning!',
        solution: 'Solution:',
        minutes: 'min',
        hoursShort: 'h',
        players: 'Players',
        playersCount: '{count} players',
        playerCount: 'Player count',
        rank: 'Rank',
        rankNth: '{rank} place',
        points: 'Points',
        pointsLabel: 'Points',
        season: 'Season',
        seasonLabel: 'Season {range}',
        gamesCount: '{count} games',
        sessionsCount: '({count} sessions)',
        seasonsCount: '({count} seasons)',
        productsCount: 'Products: {count}',
        commission: 'Commission: {percent}%',
        code: 'Code:',
        executing: 'Running...',
        confirm: 'Confirm',
        template: 'TEMPLATE',
        templateParen: '(template)',
        globalParen: '(global)',
        platformDefault: 'Platform default',
        platformDefaultBadge: 'Platform Default',
        notDefined: 'Not set',
        selectPlaceholder: '-- Select --',
        updatedPrefix: 'Updated:'
      },
      roles: {
        member: 'Member',
        board: 'Board member',
        admin: 'Administrator'
      },
      months: {
        1: 'January',
        2: 'February',
        3: 'March',
        4: 'April',
        5: 'May',
        6: 'June',
        7: 'July',
        8: 'August',
        9: 'September',
        10: 'October',
        11: 'November',
        12: 'December'
      },
      languages: {
        fi: 'Suomi',
        en: 'English',
        sv: 'Svenska'
      },
      panel: {
        title: 'Administration',
        scoringSettings: 'Scoring settings',
        resultsMaintenance: 'Results maintenance',
        systemSettings: 'System settings',
        adsManagement: 'Ad management',
        clubSettings: 'Club settings',
        addMember: 'Add member',
        nicknamePlaceholder: 'Nickname',
        userAdded: 'User added!',
        userAddError: 'Failed to add user',
        regenerateConfirm: 'Create a new link? The old one will stop working.',
        regenerateFailed: 'Failed to regenerate link',
        regenerateSuccess: 'New link created and copied to clipboard.',
        linkFetchFailed: 'Failed to fetch link',
        linkCopyFailed: 'Failed to copy link',
        roleUpdateError: 'Failed to update role',
        deleteUserTitle: 'Delete user permanently?',
        deleteNotPossible: 'Deletion is not possible:',
        deleteNotPossibleHint: 'Use deactivation instead so the user data is kept but they cannot sign in.',
        deleteWarning: 'This permanently deletes the user. If they have game history, event attendance or other references, deletion is not possible — use deactivation instead.',
        deletePermanently: 'Delete permanently',
        memberList: 'Member list ({count})',
        showOnlyActive: 'Show active only',
        copyLinkTitle: 'Copy link',
        newLinkTitle: 'New link',
        blockTitle: 'Block (soft delete)',
        activateTitle: 'Activate',
        deletePermanentlyTitle: 'Delete permanently'
      },
      settings: {
        title: 'Club settings',
        loading: 'Loading settings...',
        categories: {
          features: 'Features',
          bgg: 'BGG',
          leaderboard: 'Leaderboard',
          analytics: 'Analytics',
          ai: '🤖 AI settings',
          prompts: '💬 Prompts',
          general: '⚙️ General',
          email: '📧 Email',
          other: '📦 Other'
        },
        features: {
          gameNightsAdminOnly: 'Suggest game nights — admins only',
          gameNightsAdminOnlyHelp: 'When enabled, only administrators can create new game night proposals. All members can still sign up.'
        },
        bgg: {
          username: 'BGG username',
          usernameHelp: 'Username whose collection is used to fetch games.',
          usernamePlaceholder: 'e.g. myboardgameclub',
          autoSync: 'Automatic sync',
          autoSyncHelp: 'Sync games automatically from BGG daily.',
          lastSync: 'Last sync',
          saveButton: 'Save BGG settings'
        },
        leaderboard: {
          visibleMetrics: 'Visible metrics',
          visibleMetricsHelp: 'Choose which metrics appear on the home page leaderboard.',
          sort: 'Sorting',
          sortHelp: 'Choose the column and direction for the home page leaderboard. Only visible columns (and Games) can be selected.',
          sortColumn: 'Sort column',
          sortDirection: 'Sort direction',
          sortDesc: 'Descending (highest first)',
          sortAsc: 'Ascending (lowest first)',
          saveButton: 'Save leaderboard settings',
          metrics: {
            time: { label: 'Time', description: 'Total play time' },
            points: { label: 'Success points', description: 'Total success points' },
            winRate: { label: 'Win rate per own game', description: 'Win rate in games you played' },
            avgPoints: { label: 'Average success points per game played', description: 'Average points earned per game' }
          },
          sortLabels: {
            games: 'Games',
            time: 'Time',
            points: 'Success points',
            winRate: 'Win %',
            avgPoints: 'Avg. SP / game'
          }
        },
        analytics: {
          visibilityTitle: 'Analytics visibility and order',
          visibilityHelp: 'Choose which analytics sections are shown and in what order. You can also set whether they are expanded or collapsed by default. New sections (Success points, Medal placement %, Medal table) are added automatically if not yet saved.',
          saveButton: 'Save analytics settings'
        }
      },
      analyticsSections: {
        summary: 'Summary',
        longestGames: 'Longest games',
        mostPlayed: 'Most played games',
        winRates: 'Win rates',
        winStreaks: 'Win streaks',
        highestScores: 'Highest scores',
        closestGames: 'Closest games',
        playerFavorites: 'Player favourites',
        monthlyActivity: 'Monthly activity',
        headToHead: 'Head-to-head',
        avgPointsPerGame: 'Average success points earned',
        pointsLeaderboard: 'Success points',
        medalPercentage: 'Medal placement %',
        medalTable: 'Medal table',
        socialNemesis: 'Nemesis',
        socialKingmaker: 'Kingmaker',
        socialCloser: 'Closer',
        socialChoker: 'Choker',
        socialGiantSlayer: 'Giant Slayer',
        socialSpecialist: 'Specialist',
        socialRivalry: 'Rivalry',
        socialSkill: 'Skill rating'
      },
      club: {
        title: 'Club settings',
        saveChanges: 'Save changes',
        tabs: {
          branding: 'Appearance',
          localization: 'Language',
          media: 'Media',
          scripts: 'Scripts',
          seasons: 'Season'
        },
        branding: {
          title: 'Branding',
          clubName: 'Club name',
          clubNamePlaceholder: 'e.g. Downtown Dice Club',
          description: 'Description',
          descriptionPlaceholder: 'Short description of the club...',
          primaryColor: 'Primary colour',
          sampleColors: 'Sample colours:',
          logoPreviewAlt: 'Logo preview'
        },
        localization: {
          title: 'Language and region',
          uiLanguage: 'Interface language',
          info: 'Changing the language affects interface text. User-entered content stays in its original language.'
        },
        media: {
          title: 'Images and videos',
          logoUrl: 'Logo URL',
          heroVideoUrl: 'Hero video URL',
          heroVideoHelp: 'The video is shown in the home page background. Recommended size: 1920×1080, MP4 format.'
        },
        scripts: {
          title: 'Custom scripts',
          warning: 'Scripts run on this club\'s pages as-is (Google Analytics, widgets). Only add scripts from trusted sources. iframe and HTTP URLs are blocked.',
          addScript: 'Add script',
          noDescription: 'No description',
          addFailed: 'Failed to add script',
          deleteConfirm: 'Are you sure you want to remove this script?',
          modalTitle: 'Add script',
          position: 'Position',
          description: 'Description',
          descriptionPlaceholder: 'e.g. Google Analytics',
          script: 'Script',
          scriptPlaceholder: '<script>...</script>',
          positions: {
            head_start: 'Head (start)',
            head_end: 'Head (end)',
            body_start: 'Body (start)',
            body_end: 'Body (end)'
          }
        },
        seasons: {
          title: 'Season period',
          info: 'Define when a season starts and ends. The default is 1 Aug – 30 Jun. Sessions are grouped into seasons automatically based on these dates.',
          start: 'Season start',
          end: 'Season end',
          preview: 'Preview:',
          previewRange: 'Season: {startDay}/{startMonth} – {endDay}/{endMonth}.',
          nextYear: ' (next year)',
          saveButton: 'Save season period',
          maxDurationError: 'A season may last at most 12 months. Also check the dates.',
          saveError: 'Failed to save season period',
          migrationTitle: 'Confirm migration',
          migrationBody: 'You have {total} sessions, of which {affected} will move to a different season with the new settings.',
          migrationChanges: 'Changes:',
          migrationSessionLine: '{change}: {count} sessions',
          migrationWarning: 'What happens: New seasons are created automatically and sessions are moved into them. The club\'s most-used scoring strategy is applied to all seasons and results are recalculated.',
          confirmMigration: 'Confirm migration'
        }
      },
      results: {
        title: 'Results maintenance',
        subtitle: 'Manage game sessions by season. You can edit or delete results.',
        loading: 'Loading results...',
        loadSessionError: 'Failed to load session details',
        errorPrefix: 'Error:',
        updateFailed: 'Update failed',
        editSession: 'Edit session',
        deleteTitle: 'Are you sure you want to delete?',
        deleteWarning: 'This permanently deletes the session and all related results.',
        noSessions: 'No sessions',
        date: 'Date',
        game: 'Game',
        scores: 'Points',
        clickImageTitle: 'Click to open image',
        noImageTitle: 'No image',
        sessionImageAlt: 'Session'
      },
      scoring: {
        title: 'Scoring settings',
        loading: 'Loading scoring settings...',
        loadFailed: 'Failed to load scoring settings',
        tabs: {
          overview: 'Overview',
          strategies: 'Strategies',
          seasons: 'Seasons'
        },
        strategiesTab: 'Strategies ({count})',
        seasonsTab: 'Seasons ({count})',
        clubStrategiesTitle: 'Club scoring strategies',
        clubStrategiesHelp: 'Create a new strategy by copying a template or your own strategy. Templates cannot be edited but can be adopted.',
        ownStrategies: 'Own strategies',
        noOwnStrategies: 'No own strategies yet. Create one by copying a template.',
        templatesReadonly: 'Templates (read-only)',
        copyForUse: 'Copy for use',
        cloneTitle: 'Copy strategy',
        cloningFrom: 'Copying:',
        newStrategyName: 'New strategy name',
        namePlaceholder: 'Enter a name',
        copySuffix: ' (copy)',
        deleteStrategyTitle: 'Delete strategy',
        deleteStrategyWarning: 'Strategy "{name}" is used by {count} season(s). Choose a replacement strategy before deleting.',
        replacementStrategy: 'Replacement strategy',
        replacementHelp: 'Seasons using this strategy will be updated to use the selected replacement.',
        deleteStrategyButton: 'Delete strategy',
        editStrategy: 'Edit: {name}',
        customScoring: 'Custom scoring',
        platformDefaultScoring: 'Platform default scoring',
        customScoringHelp: 'Your club uses its own custom scoring.',
        platformDefaultHelp: 'The platform default scoring is in use. You can create custom scoring if needed.',
        creating: 'Creating...',
        createCustomScoring: 'Create custom scoring',
        scoreTable: 'Points table',
        scoreTableHelp: 'Shows points for each placement at different player counts',
        scoringRanges: 'Scoring ranges',
        playersRange: '{min}–{max} players',
        playersRangeOpen: '{min}–∞ players',
        strategyTypeTable: '📊 Table',
        strategyTypeFormula: '📐 Formula',
        formulaLabel: 'Formula:',
        variablesLabel: 'Variables:',
        strategyCloned: 'Strategy copied!',
        cloneFailed: 'Copy failed',
        strategyDeleted: 'Strategy deleted!',
        strategyDeletedUpdated: 'Strategy deleted and seasons updated!',
        customScoringCreated: 'Custom scoring created!',
        createFailed: 'Creation failed',
        seasonStrategyUpdated: 'Season scoring updated!',
        seasonPointsRecalculated: 'Season points recalculated.',
        updateFailed: 'Update failed',
        seasonsTitle: 'Seasons and scoring',
        seasonsHelp: 'Each season can have its own scoring strategy. A change is previewed and recalculates session points for that season.',
        noSeasons: 'No seasons yet. Seasons are created automatically when game sessions are added.',
        changeScoringTitle: 'Change scoring',
        recalcTitle: 'Recalculation',
        recalcHelp: 'Changing the strategy recalculates league points for the season’s sessions. Review the preview before confirming.',
        confirmRecalc: 'Confirm and recalculate',
        diffPreview: {
          summary: '{sessions} sessions, {results} results. Changed: {changedResults} results ({changedSessions} sessions). Points total {oldSum} → {newSum} ({delta}).',
          date: 'Date',
          game: 'Game',
          player: 'Player',
          rank: 'Rank',
          old: 'Old',
          new: 'New',
          truncated: 'Showing the first changed rows.',
          noChanges: 'No point differences from the current results.'
        },
        calculator: 'Calculator (preview)',
        calculatorHelp: 'Test how the current settings affect points.'
      },
      strategyManager: {
        defaultTitle: 'Scoring strategies',
        loading: 'Loading scoring strategies...',
        selectStrategy: 'Select strategy',
        strategyName: 'Strategy name',
        strategyNamePlaceholder: 'E.g. Club default',
        descriptionOptional: 'Description (optional)',
        descriptionPlaceholder: 'E.g. 2–8 players table, 9+ formula',
        editNameTitle: 'Edit name',
        playerRanges: 'Player count ranges',
        addRange: 'Add range',
        noRanges: 'No player count ranges. Add the first range to get started.',
        deleteRangeConfirm: 'Are you sure you want to delete this range?',
        typeTable: 'Table',
        typeFormula: 'Formula',
        addRangeTitle: 'Add player count range',
        rangeNameOptional: 'Name (optional)',
        rangeNamePlaceholder: 'e.g. Small games',
        minPlayers: 'Minimum player count',
        maxPlayers: 'Maximum player count',
        noUpperLimit: 'No upper limit (∞)',
        strategyType: 'Strategy type',
        createRange: 'Create range',
        formulaSingleExpression: 'Formula (single expression)',
        formulaTemplates: 'Templates:',
        templateTop3: 'Top 3 earn points',
        templateLinear: 'Linear (N points → 1)',
        templateWinnerTakesAll: 'Winner takes all',
        syntaxTitle: 'Syntax:',
        syntaxExpression: 'The formula must be a single expression (no assignments =).',
        syntaxCondition: 'Condition:',
        syntaxConditionExample: 'condition ? value_true : value_false',
        syntaxFunctions: 'Functions:',
        syntaxVariables: 'Variables:',
        variablesHeading: 'Variables:',
        fullPreviewTable: 'Full points table (preview)'
      },
      ads: {
        title: 'Ad management',
        loading: 'Loading ad management...',
        notEnabled: 'This feature is not enabled for this club. A SuperAdmin can enable it in the club\'s beta features.',
        tabs: {
          sponsors: 'Sponsors',
          products: 'Products',
          analytics: 'Analytics'
        },
        sponsorsTitle: 'Sponsors ({count})',
        addSponsor: 'Add sponsor',
        editSponsor: 'Edit sponsor',
        productsTitle: 'Products ({count})',
        addProduct: 'Add product',
        editProduct: 'Edit product',
        analyticsTitle: 'Ad analytics (30 days)',
        impressions: 'Impressions',
        clicks: 'Clicks',
        ctr: 'CTR',
        revenue: 'Revenue',
        noAnalytics: 'No analytics data for the selected period.',
        deleteProductConfirm: 'Delete product?',
        product: 'Product',
        sponsor: 'Sponsor',
        price: 'Price',
        category: 'Category',
        priority: 'Priority',
        nameRequired: 'Name *',
        logoUrl: 'Logo URL',
        website: 'Website',
        affiliateCode: 'Affiliate code',
        commissionPercent: 'Commission %',
        tier: 'Tier',
        sponsorRequired: 'Sponsor *',
        productNameRequired: 'Product name *',
        description: 'Description',
        imageUrl: 'Image URL',
        productUrlRequired: 'Product URL *',
        priceEur: 'Price €',
        salePriceEur: 'Sale price €',
        categories: {
          expansion: 'Expansion',
          accessory: 'Accessory',
          game: 'Game',
          snacks: 'Snacks'
        }
      }
    }
  },
  sv: {
    admin: {
      common: {
        cancel: 'Avbryt',
        save: 'Spara',
        saving: 'Sparar...',
        saved: 'Sparat!',
        create: 'Skapa',
        add: 'Lägg till',
        delete: 'Ta bort',
        edit: 'Redigera',
        copy: 'Kopiera',
        on: 'På',
        off: 'Av',
        visible: 'Synlig',
        hidden: 'Dold',
        expanded: 'Utfälld',
        collapsed: 'Stängd',
        active: 'Aktiv',
        blocked: 'Blockerad',
        name: 'Namn',
        role: 'Roll',
        actions: 'Åtgärder',
        day: 'Dag',
        unknown: 'Okänd',
        unknownError: 'Okänt fel',
        networkError: 'Nätverksfel',
        deleteFailed: 'Borttagning misslyckades',
        saveFailed: 'Sparning misslyckades',
        loadingSettings: 'Laddar inställningar...',
        updatedAt: 'Uppdaterad:',
        show: 'Visa',
        hide: 'Dölj',
        warning: 'Varning',
        warningExclaim: 'Varning!',
        solution: 'Lösning:',
        minutes: 'min',
        hoursShort: 'h',
        players: 'Spelare',
        playersCount: '{count} spelare',
        playerCount: 'Antal spelare',
        rank: 'Placering',
        rankNth: '{rank}:a plats',
        points: 'Poäng',
        pointsLabel: 'Poäng',
        season: 'Säsong',
        seasonLabel: 'Säsong {range}',
        gamesCount: '{count} spel',
        sessionsCount: '({count} sessioner)',
        seasonsCount: '({count} säsonger)',
        productsCount: 'Produkter: {count}',
        commission: 'Provision: {percent}%',
        code: 'Kod:',
        executing: 'Kör...',
        confirm: 'Bekräfta',
        template: 'MALL',
        templateParen: '(mall)',
        globalParen: '(global)',
        platformDefault: 'Plattformens standard',
        platformDefaultBadge: 'Platform Default',
        notDefined: 'Ej angiven',
        selectPlaceholder: '-- Välj --',
        updatedPrefix: 'Uppdaterad:'
      },
      roles: {
        member: 'Medlem',
        board: 'Styrelsemedlem',
        admin: 'Administratör'
      },
      months: {
        1: 'Januari',
        2: 'Februari',
        3: 'Mars',
        4: 'April',
        5: 'Maj',
        6: 'Juni',
        7: 'Juli',
        8: 'Augusti',
        9: 'September',
        10: 'Oktober',
        11: 'November',
        12: 'December'
      },
      languages: {
        fi: 'Suomi',
        en: 'English',
        sv: 'Svenska'
      },
      panel: {
        title: 'Administration',
        scoringSettings: 'Poänginställningar',
        resultsMaintenance: 'Resultatunderhåll',
        systemSettings: 'Systeminställningar',
        adsManagement: 'Annonsadministration',
        clubSettings: 'Klubbinställningar',
        addMember: 'Lägg till medlem',
        nicknamePlaceholder: 'Smeknamn',
        userAdded: 'Användare tillagd!',
        userAddError: 'Det gick inte att lägga till användaren',
        regenerateConfirm: 'Vill du skapa en ny länk? Den gamla slutar fungera.',
        regenerateFailed: 'Det gick inte att förnya länken',
        regenerateSuccess: 'Ny länk skapad och kopierad till urklipp.',
        linkFetchFailed: 'Det gick inte att hämta länken',
        linkCopyFailed: 'Det gick inte att kopiera länken',
        roleUpdateError: 'Det gick inte att uppdatera rollen',
        deleteUserTitle: 'Ta bort användaren permanent?',
        deleteNotPossible: 'Borttagning är inte möjlig:',
        deleteNotPossibleHint: 'Använd blockering i stället så att användardata behålls men personen inte kan logga in.',
        deleteWarning: 'Detta tar bort användaren permanent. Om personen har spelhistorik, deltagande i spelkvällar eller andra referenser går borttagning inte — använd blockering i stället.',
        deletePermanently: 'Ta bort permanent',
        memberList: 'Medlemslista ({count})',
        showOnlyActive: 'Visa endast aktiva',
        copyLinkTitle: 'Kopiera länk',
        newLinkTitle: 'Ny länk',
        blockTitle: 'Blockera (mjuk borttagning)',
        activateTitle: 'Aktivera',
        deletePermanentlyTitle: 'Ta bort permanent'
      },
      settings: {
        title: 'Klubbinställningar',
        loading: 'Laddar inställningar...',
        categories: {
          features: 'Funktioner',
          bgg: 'BGG',
          leaderboard: 'Topplista',
          analytics: 'Analyser',
          ai: '🤖 AI-inställningar',
          prompts: '💬 Prompter',
          general: '⚙️ Allmänt',
          email: '📧 E-post',
          other: '📦 Övrigt'
        },
        features: {
          gameNightsAdminOnly: 'Föreslå spelkvällar — endast admin',
          gameNightsAdminOnlyHelp: 'När detta är på kan endast administratörer skapa nya förslag på spelkvällar. Alla medlemmar kan fortfarande anmäla sig.'
        },
        bgg: {
          username: 'BGG-användarnamn',
          usernameHelp: 'Användarnamn vars samling används för att hämta spel.',
          usernamePlaceholder: 't.ex. spelklubben123',
          autoSync: 'Automatisk synkronisering',
          autoSyncHelp: 'Synkronisera spel automatiskt från BGG dagligen.',
          lastSync: 'Senaste synkronisering',
          saveButton: 'Spara BGG-inställningar'
        },
        leaderboard: {
          visibleMetrics: 'Synliga mått',
          visibleMetricsHelp: 'Välj vilka mått som visas i topplistan på startsidan.',
          sort: 'Sortering',
          sortHelp: 'Välj kolumn och riktning för topplistan på startsidan. Endast synliga kolumner (och Spel) kan väljas.',
          sortColumn: 'Sorteringskolumn',
          sortDirection: 'Sorteringsriktning',
          sortDesc: 'Fallande (högst först)',
          sortAsc: 'Stigande (lägst först)',
          saveButton: 'Spara topplistinställningar',
          metrics: {
            time: { label: 'Tid', description: 'Total speltid' },
            points: { label: 'Framgångspoäng', description: 'Totala framgångspoäng' },
            winRate: { label: 'Vinstprocent per eget spel', description: 'Vinstprocent i egna spel' },
            avgPoints: { label: 'Genomsnittliga framgångspoäng per spelat spel', description: 'Genomsnittligt intjänade poäng per spel' }
          },
          sortLabels: {
            games: 'Spel',
            time: 'Tid',
            points: 'Framgångspoäng',
            winRate: 'Vinst-%',
            avgPoints: 'Snitt FP / spel'
          }
        },
        analytics: {
          visibilityTitle: 'Analysers synlighet och ordning',
          visibilityHelp: 'Ange vilka analyser som visas och i vilken ordning. Du kan också ange om de ska vara utfällda eller stängda som standard. Nya avsnitt (Framgångspoäng, Medaljplacering %, Medaljtabell) läggs till automatiskt om de ännu inte är sparade.',
          saveButton: 'Spara analysinställningar'
        }
      },
      analyticsSections: {
        summary: 'Sammanfattning',
        longestGames: 'Längsta spelen',
        mostPlayed: 'Mest spelade spel',
        winRates: 'Vinstprocent',
        winStreaks: 'Vinster i rad',
        highestScores: 'Högsta poäng',
        closestGames: 'Jämnaste spelen',
        playerFavorites: 'Spelarnas favoriter',
        monthlyActivity: 'Månadsaktivitet',
        headToHead: 'Inbördes möten',
        avgPointsPerGame: 'Genomsnittlig framgångspoäng',
        pointsLeaderboard: 'Framgångspoäng',
        medalPercentage: 'Medaljplacering-%',
        medalTable: 'Medaljtabell',
        socialNemesis: 'Nemesis',
        socialKingmaker: 'Kingmaker',
        socialCloser: 'Closer',
        socialChoker: 'Choker',
        socialGiantSlayer: 'Giant Slayer',
        socialSpecialist: 'Specialist',
        socialRivalry: 'Rivalry',
        socialSkill: 'Skill-rating'
      },
      club: {
        title: 'Klubbinställningar',
        saveChanges: 'Spara ändringar',
        tabs: {
          branding: 'Utseende',
          localization: 'Språk',
          media: 'Media',
          scripts: 'Skript',
          seasons: 'Säsong'
        },
        branding: {
          title: 'Varumärke',
          clubName: 'Klubbnamn',
          clubNamePlaceholder: 't.ex. Göteborgs tärningsklubb',
          description: 'Beskrivning',
          descriptionPlaceholder: 'Kort beskrivning av klubben...',
          primaryColor: 'Primärfärg',
          sampleColors: 'Exempelfärger:',
          logoPreviewAlt: 'Logoförhandsvisning'
        },
        localization: {
          title: 'Språk och region',
          uiLanguage: 'Gränssnittsspråk',
          info: 'Byte av språk påverkar gränssnittstexter. Användargenererat innehåll behåller sitt ursprungliga språk.'
        },
        media: {
          title: 'Bilder och videor',
          logoUrl: 'Logo-URL',
          heroVideoUrl: 'Hero-video-URL',
          heroVideoHelp: 'Videon visas i bakgrunden på startsidan. Rekommenderad storlek: 1920×1080, MP4-format.'
        },
        scripts: {
          title: 'Anpassade skript',
          warning: 'Skript körs på den här klubbens sidor i oförändrat skick (Google Analytics, widgetar). Lägg endast till skript från betrodda källor. iframe och HTTP-adresser blockeras.',
          addScript: 'Lägg till skript',
          noDescription: 'Ingen beskrivning',
          addFailed: 'Det gick inte att lägga till skriptet',
          deleteConfirm: 'Vill du verkligen ta bort det här skriptet?',
          modalTitle: 'Lägg till skript',
          position: 'Placering',
          description: 'Beskrivning',
          descriptionPlaceholder: 't.ex. Google Analytics',
          script: 'Skript',
          scriptPlaceholder: '<script>...</script>',
          positions: {
            head_start: 'Head (början)',
            head_end: 'Head (slut)',
            body_start: 'Body (början)',
            body_end: 'Body (slut)'
          }
        },
        seasons: {
          title: 'Säsongsperiod',
          info: 'Ange när en säsong börjar och slutar. Standard är 1 aug – 30 jun. Sessioner grupperas automatiskt i säsonger enligt dessa datum.',
          start: 'Säsongens start',
          end: 'Säsongens slut',
          preview: 'Förhandsvisning:',
          previewRange: 'Säsong: {startDay}.{startMonth}. – {endDay}.{endMonth}.',
          nextYear: ' (nästa år)',
          saveButton: 'Spara säsongsperiod',
          maxDurationError: 'En säsong får vara högst 12 månader. Kontrollera även datumen.',
          saveError: 'Det gick inte att spara säsongsperioden',
          migrationTitle: 'Bekräfta migrering',
          migrationBody: 'Du har {total} sessioner, varav {affected} flyttas till en annan säsong med de nya inställningarna.',
          migrationChanges: 'Ändringar:',
          migrationSessionLine: '{change}: {count} sessioner',
          migrationWarning: 'Vad som händer: Nya säsonger skapas automatiskt och sessioner flyttas dit. Klubbens mest använda poängstrategi väljs för alla säsonger och resultaten räknas om.',
          confirmMigration: 'Bekräfta migrering'
        }
      },
      results: {
        title: 'Resultatunderhåll',
        subtitle: 'Hantera spelsessioner per säsong. Du kan redigera eller ta bort resultat.',
        loading: 'Laddar resultat...',
        loadSessionError: 'Det gick inte att ladda sessionsinformation',
        errorPrefix: 'Fel:',
        updateFailed: 'Uppdatering misslyckades',
        editSession: 'Redigera session',
        deleteTitle: 'Vill du verkligen ta bort?',
        deleteWarning: 'Detta tar bort sessionen och alla tillhörande resultat permanent.',
        noSessions: 'Inga sessioner',
        date: 'Datum',
        game: 'Spel',
        scores: 'Poäng',
        clickImageTitle: 'Klicka för att öppna bilden',
        noImageTitle: 'Ingen bild',
        sessionImageAlt: 'Session'
      },
      scoring: {
        title: 'Poänginställningar',
        loading: 'Laddar poänginställningar...',
        loadFailed: 'Det gick inte att ladda poänginställningarna',
        tabs: {
          overview: 'Översikt',
          strategies: 'Strategier',
          seasons: 'Säsonger'
        },
        strategiesTab: 'Strategier ({count})',
        seasonsTab: 'Säsonger ({count})',
        clubStrategiesTitle: 'Klubbens poängstrategier',
        clubStrategiesHelp: 'Skapa en ny strategi genom att kopiera en mall eller en egen strategi. Mallar kan inte redigeras men kan tas i bruk.',
        ownStrategies: 'Egna strategier',
        noOwnStrategies: 'Inga egna strategier ännu. Skapa en genom att kopiera en mall.',
        templatesReadonly: 'Mallar (skrivskyddade)',
        copyForUse: 'Kopiera för användning',
        cloneTitle: 'Kopiera strategi',
        cloningFrom: 'Kopierar:',
        newStrategyName: 'Nytt strateginamn',
        namePlaceholder: 'Ange namn',
        copySuffix: ' (kopia)',
        deleteStrategyTitle: 'Ta bort strategi',
        deleteStrategyWarning: 'Strategin "{name}" används av {count} säsong(er). Välj en ersättningsstrategi innan borttagning.',
        replacementStrategy: 'Ersättningsstrategi',
        replacementHelp: 'Säsonger som använder den här strategin uppdateras till den valda ersättningen.',
        deleteStrategyButton: 'Ta bort strategi',
        editStrategy: 'Redigera: {name}',
        customScoring: 'Anpassad poängräkning',
        platformDefaultScoring: 'Plattformens standardpoäng',
        customScoringHelp: 'Din klubb använder egen anpassad poängräkning.',
        platformDefaultHelp: 'Plattformens standardpoäng används. Du kan skapa anpassad poängräkning vid behov.',
        creating: 'Skapar...',
        createCustomScoring: 'Skapa egen poängräkning',
        scoreTable: 'Poängtabell',
        scoreTableHelp: 'Visar poäng för varje placering vid olika antal spelare',
        scoringRanges: 'Poängintervall',
        playersRange: '{min}–{max} spelare',
        playersRangeOpen: '{min}–∞ spelare',
        strategyTypeTable: '📊 Tabell',
        strategyTypeFormula: '📐 Formel',
        formulaLabel: 'Formel:',
        variablesLabel: 'Variabler:',
        strategyCloned: 'Strategi kopierad!',
        cloneFailed: 'Kopiering misslyckades',
        strategyDeleted: 'Strategi borttagen!',
        strategyDeletedUpdated: 'Strategi borttagen och säsonger uppdaterade!',
        customScoringCreated: 'Anpassad poängräkning skapad!',
        createFailed: 'Skapande misslyckades',
        seasonStrategyUpdated: 'Säsongens poäng uppdaterad!',
        seasonPointsRecalculated: 'Säsongens poäng har räknats om.',
        updateFailed: 'Uppdatering misslyckades',
        seasonsTitle: 'Säsonger och poäng',
        seasonsHelp: 'Varje säsong kan ha en egen poängstrategi. Ändringen förhandsvisas och räknar om sessionernas poäng för säsongen.',
        noSeasons: 'Inga säsonger ännu. Säsonger skapas automatiskt när spelsessioner läggs till.',
        changeScoringTitle: 'Byt poängräkning',
        recalcTitle: 'Omräkning',
        recalcHelp: 'Strategibyte räknar om säsongens sessioners ligapoäng. Kontrollera förhandsvisningen innan du bekräftar.',
        confirmRecalc: 'Bekräfta och räkna om',
        diffPreview: {
          summary: '{sessions} sessioner, {results} resultat. Ändras: {changedResults} resultat ({changedSessions} sessioner). Poängsumma {oldSum} → {newSum} ({delta}).',
          date: 'Datum',
          game: 'Spel',
          player: 'Spelare',
          rank: 'Placering',
          old: 'Gammal',
          new: 'Ny',
          truncated: 'De första ändrade raderna visas.',
          noChanges: 'Inga poängskillnader mot de nuvarande resultaten.'
        },
        calculator: 'Kalkylator (förhandsvisning)',
        calculatorHelp: 'Testa hur nuvarande inställningar påverkar poängen.'
      },
      strategyManager: {
        defaultTitle: 'Poängstrategier',
        loading: 'Laddar poängstrategier...',
        selectStrategy: 'Välj strategi',
        strategyName: 'Strateginamn',
        strategyNamePlaceholder: 'T.ex. Klubbens standard',
        descriptionOptional: 'Beskrivning (valfritt)',
        descriptionPlaceholder: 'T.ex. 2–8 spelare tabell, 9+ formel',
        editNameTitle: 'Redigera namn',
        playerRanges: 'Spelarantalsintervall',
        addRange: 'Lägg till intervall',
        noRanges: 'Inga spelarantalsintervall. Lägg till det första intervallet för att komma igång.',
        deleteRangeConfirm: 'Vill du verkligen ta bort det här intervallet?',
        typeTable: 'Tabell',
        typeFormula: 'Formel',
        addRangeTitle: 'Lägg till spelarantalsintervall',
        rangeNameOptional: 'Namn (valfritt)',
        rangeNamePlaceholder: 't.ex. Små spel',
        minPlayers: 'Minsta antal spelare',
        maxPlayers: 'Största antal spelare',
        noUpperLimit: 'Ingen övre gräns (∞)',
        strategyType: 'Strategityp',
        createRange: 'Skapa intervall',
        formulaSingleExpression: 'Formel (enskilt uttryck)',
        formulaTemplates: 'Mallar:',
        templateTop3: 'Topp 3 får poäng',
        templateLinear: 'Linjär (N poäng → 1)',
        templateWinnerTakesAll: 'Vinnaren tar allt',
        syntaxTitle: 'Syntax:',
        syntaxExpression: 'Formeln måste vara ett enskilt uttryck (inga tilldelningar =).',
        syntaxCondition: 'Villkor:',
        syntaxConditionExample: 'villkor ? varde_sant : varde_falskt',
        syntaxFunctions: 'Funktioner:',
        syntaxVariables: 'Variabler:',
        variablesHeading: 'Variabler:',
        fullPreviewTable: 'Fullständig poängtabell (förhandsvisning)'
      },
      ads: {
        title: 'Annonsadministration',
        loading: 'Laddar annonsadministration...',
        notEnabled: 'Den här funktionen är inte aktiverad för den här klubben. En SuperAdmin kan aktivera den i klubbens betafunktioner.',
        tabs: {
          sponsors: 'Sponsorer',
          products: 'Produkter',
          analytics: 'Analys'
        },
        sponsorsTitle: 'Sponsorer ({count})',
        addSponsor: 'Lägg till sponsor',
        editSponsor: 'Redigera sponsor',
        productsTitle: 'Produkter ({count})',
        addProduct: 'Lägg till produkt',
        editProduct: 'Redigera produkt',
        analyticsTitle: 'Annonsanalys (30 dagar)',
        impressions: 'Visningar',
        clicks: 'Klick',
        ctr: 'CTR',
        revenue: 'Intäkt',
        noAnalytics: 'Ingen analysdata för den valda perioden.',
        deleteProductConfirm: 'Ta bort produkt?',
        product: 'Produkt',
        sponsor: 'Sponsor',
        price: 'Pris',
        category: 'Kategori',
        priority: 'Prioritet',
        nameRequired: 'Namn *',
        logoUrl: 'Logo-URL',
        website: 'Webbplats',
        affiliateCode: 'Affiliate-kod',
        commissionPercent: 'Provision %',
        tier: 'Nivå',
        sponsorRequired: 'Sponsor *',
        productNameRequired: 'Produktnamn *',
        description: 'Beskrivning',
        imageUrl: 'Bild-URL',
        productUrlRequired: 'Produkt-URL *',
        priceEur: 'Pris €',
        salePriceEur: 'Reapris €',
        categories: {
          expansion: 'Tillägg',
          accessory: 'Tillbehör',
          game: 'Spel',
          snacks: 'Snacks'
        }
      }
    }
  }
};

export function formatAdmin(t, template, params = {}) {
  return Object.entries(params).reduce(
    (str, [key, value]) => str.replace(new RegExp(`\\{${key}\\}`, 'g'), String(value)),
    template
  );
}

export function adminLocale(language) {
  const map = { fi: 'fi-FI', en: 'en-GB', sv: 'sv-SE' };
  return map[language] || 'fi-FI';
}

export default adminTranslations;
